// Names of feature flags.

export const FEATURE_DETAILED_READINGCARDS = 'rxentry_detailed_readingcards';
export const FEATURE_MEASUREMENT_DATEFILTER = 'rxentry_measurement_datefilter';
export const FEATURE_ALLOW_PRINT_RX = 'rxentry_allow_print_rx';
export const MULTIFOCAL_CONTACTS_FEATURE_FLAG = 'shop_app_multifocal_contacts';
export const EXPANDED_RX_FEATURE_FLAG = 'shop_app_expanded_rx';
